<template>
	<div>
		<TripTravelersCounter v-model.number="leadForm.numTravelers" class="mb-6" />
		<TripBudgetSelector v-model:budget="leadForm.budget" :error="formErrors?.budget" />
		<PhoneInput
			v-model="leadForm.phone"
			v-model:selected-prefix="leadForm.phonePrefix"
			:placeholder="$t('web.contact_modal.form.phone.placeholder')"
			:label="$t('web.contact_modal.form.phone.label')"
			:helper-text="$t('web.contact_modal.form.phone.help_text')"
			:error="formErrors?.phone"
		/>
	</div>
</template>

<script setup lang="ts">
	import { LeadFormInfo } from '~/actions/trip/lead'

	interface Props {
		formErrors?: Record<keyof LeadFormInfo, string>
	}
	defineProps<Props>()

	const leadForm = defineModel<LeadFormInfo>({
		default: {
			phone: '',
			phonePrefix: '',
			numTravelers: 1,
			budget: undefined,
		},
	})
</script>

<style lang="scss" scoped></style>
